import * as React from "react";
import {CurrentUser, OfferClaim, UserCard} from "../../types/Types";
import {useState} from "react";
import {useEffect} from "react";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";
import DisplayListControl from "../list/DisplayListControl";
import {convertTimestampToDateAndTime} from "../../utils/Utils";
import "./OfferClaim.css"

interface Props {
  currentUser: CurrentUser,
  offerId: string,
  offerCard: UserCard | undefined,
  defaultDisplayList: boolean,
  highlightNewClaim: boolean,
}

function OfferClaimList(props: Props) {
  const [offerClaims, setOfferClaims] = useState<Array<OfferClaim>>([]);
  const [displayList, setDisplayList] = useState<boolean>(props.defaultDisplayList);

  useEffect(() => {(async () => {
    let offerClaims = new Array<OfferClaim>();
    let offerClaimsCollection = undefined;
    if(props.offerCard) {
      offerClaimsCollection = query(
          collection(db, 'offer-claims'),
          where("offer", "==", props.offerId),
          where("user", "==", props.offerCard.user),
          orderBy("createdAt", "desc"),
          limit(1000),
      );
    } else {
      offerClaimsCollection = query(
          collection(db, 'offer-claims'),
          where("offer", "==", props.offerId),
          orderBy("createdAt", "desc"),
          limit(1000),
      );
    }
    const offerClaimsSnapshot = await getDocs(offerClaimsCollection);
    offerClaimsSnapshot.forEach((doc) => {
      offerClaims.push(doc.data() as OfferClaim);
    });
    setOfferClaims(offerClaims);
  })()
  }, [props.offerCard]);

  return (
    <div className={"mt-3"}>
      <div className={`left-align list-title ${displayList ? "" : "mb-0"}`} onClick={() => setDisplayList(!displayList)}>
        <b>Claim History</b>
        <DisplayListControl displayList={displayList} count={offerClaims.length}/>
      </div>
      {displayList && <div>
        {(offerClaims && offerClaims.length > 0) && offerClaims.map((offerClaim, index) => (
            <div className={`left-align claim-row ${index === 0 ? 'claim-row-top' : ''} ${index === offerClaims.length-1 ? 'mb-0 claim-row-bottom' : 'dotted-border'} ${index === 0 && props.highlightNewClaim ? 'light-green' : ''}`}>
              <div className={"d-inline-block font-weight-500"}>{offerClaim.userName}</div>
              <div className={"d-inline-block float-right"}>Claim: <b>{offerClaim.claimNumber}</b></div>
              <div className={"d-block font-sm1"} style={{marginTop: "-8px"}}>{convertTimestampToDateAndTime(offerClaim.createdAt)}</div>
            </div>
        ))}
        {(offerClaims && offerClaims.length === 0) && <div className={"basic-box mb-0"}>No claims made.</div>}
      </div>}
    </div>
  )
}

export default OfferClaimList;